/* eslint func-names: ["error", "never"] */
const scrollMonitor = require('../../libs/scrollMonitor');

// intro page animations
$(() => {
  const $intro = $('.js-intro-page');

  $('.js-plane').hover(function () {
    const path = $(this).data('path');

    if (path === 'out') {
      $intro.addClass('plane-out');
    } else {
      $intro.addClass('plane-in');
    }
  }, () => {
    $intro.removeClass('plane-out plane-in');
  });

  // animation when in viewport
  $('.js-fade-up').each(function () {
    const $el = $(this);
    const elWatcher = scrollMonitor.create($el, { top: -100 });

    elWatcher.enterViewport(function () {
      $(this.watchItem).addClass('in-viewport');
    });
  });

  // animation svx text
  (function () {
    const $el = $('.js-per-rotate');

    function setRotate(valScroll) {
      const rotate = valScroll / 6 > 90 ? 90 : valScroll / 6;
      const styles = {
        transform: `perspective(500px) rotateX(-${rotate}deg)`,
      };
      $el.css(styles);
    }

    $(window).scroll(function () {
      const y = this.scrollY || this.pageYOffset;
      setRotate(y);
    });
  }());
});



// WEBPACK FOOTER //
// ./src/scripts/components/animations/index.js